import { render, staticRenderFns } from "./pendiente-pago.vue?vue&type=template&id=546e8fa4"
import script from "./pendiente-pago.vue?vue&type=script&lang=js"
export * from "./pendiente-pago.vue?vue&type=script&lang=js"
import style0 from "./pendiente-pago.vue?vue&type=style&index=0&id=546e8fa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports